import client from "./axios.service";

export const getAllPermissions = () => client.get("/permissions", null);

export const addPermission = (key: string) => client.post("/permissions", { key }, null);
